export function asNumber(value: number | string | null | undefined): number | null {
  if (value === null || value === undefined || value === '') return null
  const parsed = typeof value === 'number' ? value : Number(value)
  return Number.isFinite(parsed) ? parsed : null
}

export function asCount(value: number | string | null | undefined): number {
  return asNumber(value) ?? 0
}
